import { Fragment } from 'react';
import { useTranslation } from '@hotjar/translations';
import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';
import type { SurveyData } from '@hotjar/webapp/domains/activation/featured-insights/types';

const SurveyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${tokens.spacer.x3} ${tokens.spacer.x3pt5};
  justify-content: center;
`;

const SurveyQuestion = styled(Text)`
  line-height: 20px;
`;

const ANSWER_TRIM: Record<number, number> = {
  1: 11,
  2: 5,
  3: 3,
  4: 2,
};

const SurveyAnswer = styled(Text)<{ answersCount: number }>`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ answersCount }) => (answersCount <= 4 ? ANSWER_TRIM[answersCount] : 2)};
  margin-bottom: ${tokens.spacer.x3};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const MAX_VISIBLE_QUESTIONS = 3;

export const SurveyMainSection = ({ data }: { data: SurveyData }): JSX.Element => {
  const { t } = useTranslation();
  const questions = data?.answers || [];
  const questionsTotal = questions.length;

  return (
    <SurveyContainer>
      {questions.slice(0, MAX_VISIBLE_QUESTIONS).map((item) => (
        <Fragment key={item?.question.id}>
          <SurveyQuestion textColor="text_light" textType="caption">
            {item?.question.text}
          </SurveyQuestion>
          <SurveyAnswer
            answersCount={questionsTotal}
            textType={[1, 2].includes(questionsTotal) ? 'body1' : 'body2'}
          >
            {item?.content[0]?.value.toString().length === 0 ? '-' : item?.content[0]?.value}
          </SurveyAnswer>
        </Fragment>
      ))}
      {questionsTotal > MAX_VISIBLE_QUESTIONS ? (
        <SurveyQuestion textColor="text_light" textType="caption">
          {t(
            'activation:space-overview.for-you.featured-insights.slider.slide.survey.more-questions',
            {
              count: questionsTotal - MAX_VISIBLE_QUESTIONS,
            },
          )}
        </SurveyQuestion>
      ) : null}
    </SurveyContainer>
  );
};
